class EmployeesController implements ng.IComponentController {

    constructor() {
        'ngInject';
        // console.log('EmployeesController');
    }
}

export const employeesComponent : ng.IComponentOptions = {
    controller : EmployeesController,
    template : require('./employees.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/employees/employees.component.ts